
import React, { useState, useEffect, useRef } from "react";
import {
    Input,
    Table,
    Tag,
    Button,
    message,
    Form,
    Row,
    Select,
    DatePicker,
    Col,
    Modal,
    Card,
    Radio,
} from "antd";
import Service from "../../service";
import moment from "moment";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import { useDispatch, useSelector } from "react-redux";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json"
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import useCompanyDateFormat from "../../hooks/useCompanyDateFormat";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../constants/tablePagination";
import EmpNameCodeCell from "../common/EmpNameCodeCell";


const { Option } = Select;
const Search = Input.Search;
const KarmaApprovelAdmin = (props) => {
    const dateFormat = useCompanyDateFormat();

    const { history } = props;
    const params = new URLSearchParams(window.location.search);
    const filter = params.get('leave_status');
    const [eventApiData, setEventApiData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
    });
    const searchRef = useRef();
    const [searchText, setSearchText] = useState("");
    const [val, setVal] = useState(filter ? filter : "All");
    const [seachEnabled, setSearchEnabled] = useState(false);
    const [deptData, setDeptData] = useState([]);
    const [IsModalView, setIsModalView] = useState(false);
    let [filterData, setFilterData] = useState([]);
    const [eventTypeApiData, setEventTypeApiData] = useState([]);
    const [eventType, setEventType] = useState(null);
    const [departmentList, setDepartmentList] = useState([]);
    const [positionlist, setpositionList] = useState([]);
    const [eventTypeList, setEventTypeList] = useState([]);
    const [time_hours, setTime_hours] = useState([10, 0, 19, 0]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [focusedDate, setFocusedDate] = useState();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [empdropdown, setEmpDropdown] = useState([]);
    const [waffleNmae, setwaffleName] = useState([]);
    const [waffleNmaeModal, setwaffleNameModal] = useState(false);

    const [emplyeeName, setEmployeeName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isVisible, setisVisible] = useState(false);
    const [totalRecord, setTotalRecord] = useState(null);
    const [setClrFtr, setsetClrFtr] = useState(false);
    const [emplyeeNameTxt, setEmployeeNameTxt] = useState("");

    const filterFormRef = useRef();





    let { authUser } = useSelector(({ auth }) => auth);

    const onChange = (e) => {
        setVal(e.target.value);
    };



    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };

    const onSelectChange = (newSelectedRowKeys) => {
        // Ensure only unique keys are stored
        setSelectedRowKeys([...new Set(newSelectedRowKeys)]);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: record?.status !== "pending", // 🔹 Disable Non-Pending Rows
        }),
    };

    const onReset = () => {
        form.resetFields();
        // setFileList([]);
    };
    const onCancel = () => {
        if (props.history.length > 1) {
            props.history.goBack();
        } else {
            props.history.push("/event");
        }
    };
    const filterEmp = async (values) => {
        setFilterData(values);
        setIsModalView(!IsModalView);
    };

    const resetSearchFilter = (e) => {
        const keyCode = e && e.keyCode ? e.keyCode : e;
        switch (keyCode) {
            case 8:
                if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
                    searchRef.current.state.value = "";
                    setSearchEnabled(false);
                }
                break;
            case 46:
                if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
                    searchRef.current.state.value = "";
                    setSearchEnabled(false);
                }
                break;
            default:
                break;
        }
    };
    const handleTableChange = (page, filters, sorter) => {
        setPagination({ ...pagination, ...page });
    };

    useEffect(() => {
        const unloadListener = (e) => {
            if (e.currentTarget.performance.navigation.type === 1) {
                history.replace({});
            }
        };
        window.addEventListener("beforeunload", unloadListener);
        return () => {
            history.replace({});
            window.removeEventListener("beforeunload", unloadListener);
        };
    }, []);

    useEffect(() => {
        form.setFieldsValue("leave_status", val);
    }, [val]);
    useEffect(() => {
        karmaRewardGet();
    }, []);

    // Pagination changes
    useEffect(() => {
        karmaRewardGet();
    }, [pagination.current, pagination.pageSize, setClrFtr]);


    const columns = [
        {
            title: "Employee name",
            dataIndex: "employee_name",
            key: "employee_name",
            render: (text, record) => <EmpNameCodeCell name={record.empName} code={record.empCode} />,
        },
        {
            title: "Waffle Count",
            dataIndex: "reward_point",
            key: "reward_point",
            render: (text, record, index) => {
                return <span style={ { textTransform: "capitalize" } }>{ record?.waffle_amount_selected ? record?.waffle_amount_selected : 0 }</span>;
            },
        },
        {
            title: "Employee Remaining Waffle",
            dataIndex: "employee_remaining_balance",
            key: "employee_remaining_balance",
            width: "20%",
            render: (text, record, index) => {
                const event = record.empRemainingBalance
                    ;
                return <span style={ { textTransform: "capitalize" } }>{ event }</span>;
            },
        },
        {
            title: "Requested Date",
            dataIndex: "reward_point",
            key: "reward_point",
            render: (text, record, index) => {
                return <span style={ { textTransform: "capitalize" } }>{ moment(record?.createdAt).format(dateFormat) }</span>;
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text, record, index) => {
                const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
                const status = capitalize(record?.status);
                const color =
                    record?.status === "pending"
                        ? "orange"
                        : record?.status === "approved"
                            ? "green"
                            : record?.status === "rejected"
                                ? "red"
                                : "error";

                return status ? <Tag color={ color }>{ status }</Tag> : null;
            }

        },
    ];

    const WaffleNameModalOpen = () => {
        setwaffleNameModal(true)
    }
    const handleAccept = async (value) => {
        try {
            dispatch(showAuthLoader());

            const reqBody = {
                id: selectedRowKeys,
                status: "approved",
                waffel_reward_name: value?.waffleName
            };

            const response = await Service.makeAPICall({
                methodName: Service.putMethod,
                api_url: Service.karmaRewardUpdate,
                body: reqBody,
            });
            if (response.data.status == 404) {
                message.error(response.data.message);

            }
            if (response.data) {
                setSelectedRowKeys([]);
                karmaRewardGet()
                response.data.message.toLowerCase().includes("success") ?
                    message.success(response.data.message) : message.error(response.data.message);
                dispatch(hideAuthLoader());
                closeModal()
            }
            dispatch(hideAuthLoader());

        } catch (error) {
            console.log(error);
        }
    };

    const handleReject = async () => {
        try {
            dispatch(showAuthLoader());
            const reqBody = {
                id: selectedRowKeys,
                status: "rejected"
            };

            const response = await Service.makeAPICall({
                methodName: Service.putMethod,
                api_url: Service.karmaRewardUpdate,
                body: reqBody,
            });
            if (response.data.status == 404) {
                message.error(response.data.message);

            }
            if (response.data) {
                message.success(response.data.message);
                karmaRewardGet()
                setSelectedRowKeys([]);
            }
            dispatch(hideAuthLoader());
        } catch (error) {
            console.log(error);
        }
    };

    const getFooterDetails = () => {
        return (
            <label>
                Total Records Count is { totalRecord }
            </label>
        );
    };

    const closeEventModalView = () => {
        form.resetFields();
        setIsModalView(!IsModalView);
    };

    const karmaRewardGet = async () => {
        try {
            dispatch(showAuthLoader());
            const formattedStartDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
            const formattedEndDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";
            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: Service.karmaRewardGet + `?page=${pagination.current}&limit=${pagination.pageSize}&search=${emplyeeName}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
            });

            if (response.data.data) {
                setEventApiData(response.data.data);
                setTotalRecord(response.data.totalRecords)
                setisVisible(false)
            }
            dispatch(hideAuthLoader());
        } catch (error) {
            console.log(error);
        }
    }

    const closeModal = (values) => {
        setwaffleNameModal(false)
        form.resetFields();
    };
    const handleFinish = (value) => {
        handleAccept(value)
    }

    const handFiltModal = () => {
        setisVisible(true)
    }

    const clearFilter = () => {
        setEmployeeName("")
        setStartDate("")
        setEndDate("")
        setEmployeeNameTxt("")
        form.resetFields();
        setVal("All");
        setFilterData([]);

        if (filterFormRef.current) {
            filterFormRef.current.resetFields();
        }

        setPagination({ ...pagination, current: 1 });

        setsetClrFtr(prev => !prev);
    }

    useEffect(() => {
        if (emplyeeName || startDate || endDate) {
            karmaRewardGet();
        }
    }, [emplyeeName, startDate, endDate]);

    const handleFilterChange = (allValues) => {
        const filterValues = { ...allValues };

        // Update state variables that are used in API call
        if (filterValues.employeeName !== undefined) {
            setEmployeeName(filterValues.employeeName);
        }
        if (filterValues.startDate !== undefined) {
            setStartDate(filterValues.startDate);
        }
        if (filterValues.endDate !== undefined) {
            setEndDate(filterValues.endDate);
        }

        setFilterData(filterValues);
        setPagination({ ...pagination, current: 1 });
    };

    return (
        <Card className="employee-card">
            <div className=" inout-header text-left">
                <h2>Reward Approval Admin </h2>
            </div>
            <Modal
                title="Filter"
                width={ 800 }
                visible={ IsModalView }
                okText="Update"
                footer={ false }
                onCancel={ closeEventModalView }
            >
                <Form { ...formItemLayout } form={ form } onFinish={ filterEmp }>
                    <div className="add-registration leave_form">
                        <Row>
                            <Col sm={ 24 } md={ 12 }>
                                <Form.Item
                                    className="search-row"
                                    label="Approval From Date"
                                    name="approval_from_date"
                                >
                                    <DatePicker
                                        format={ "DD-MM-YYYY" }
                                        className="fulldate-width"
                                    />
                                </Form.Item>
                                <Form.Item
                                    className="search-row"
                                    label="Leave From Date"
                                    name="leave_from_date"
                                >
                                    <DatePicker
                                        format={ "DD-MM-YYYY" }
                                        className="fulldate-width"
                                    // disabledDate={disabledDate}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Employee code"
                                    name="employee_code"
                                    className="search-row"
                                >
                                    <Select
                                    defaultValue="Select"
                                        size="large"
                                        showSearch
                                        filterOption={ (input, option) =>
                                            option.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={ (optionA, optionB) =>
                                            optionA.children
                                                .toLowerCase()
                                                .localeCompare(optionB.children.toLowerCase())
                                        }
                                        onChange={ (e) => {
                                            let data = empdropdown.filter(
                                                (val) => val.emp_code == e
                                            );
                                            form.setFieldsValue({
                                                employee: data[0]?._id,
                                            });
                                        } }
                                    >
                                        { empdropdown.map((item, index) => (
                                            <Option
                                                key={ index }
                                                value={ item?.emp_code }
                                                style={ { textTransform: "capitalize" } }
                                            >
                                                { item?.emp_code }
                                            </Option>
                                        )) }
                                    </Select>
                                </Form.Item>

                            </Col>
                            <Col sm={ 24 } md={ 12 }>
                                <Form.Item
                                    label="Approval To Date"
                                    name="approval_to_date"
                                    className="search-row"
                                >
                                    <DatePicker
                                        format={ "DD-MM-YYYY" }
                                        className="fulldate-width"
                                        disabledDate={ (value) => {
                                            return value < form.getFieldValue("approval_from_date");
                                        } }
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Leave To Date"
                                    name="leave_to_date"
                                    className="search-row"
                                >
                                    <DatePicker
                                        format={ "DD-MM-YYYY" }
                                        className="fulldate-width"
                                        disabledDate={ (value) => {
                                            return value < form.getFieldValue("leave_from_date");
                                        } }
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Employee Name"
                                    name="employee"
                                    className="search-row"
                                >
                                    <Select
                                        size="large"
                                        defaultValue="Select"
                                        showSearch
                                        filterOption={ (input, option) =>
                                            option.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={ (optionA, optionB) =>
                                            optionA.children
                                                .toLowerCase()
                                                .localeCompare(optionB.children.toLowerCase())
                                        }
                                        onChange={ (e) => {
                                            let data = empdropdown.filter((val) => val._id == e);
                                            form.setFieldsValue({
                                                employee_code: data[0]?.emp_code,
                                            });
                                        } }
                                    >
                                        { empdropdown.map((item, index) => (
                                            <Option
                                                key={ index }
                                                value={ item?._id }
                                                style={ { textTransform: "capitalize" } }
                                            >
                                                { item?.first_name + " " + item?.last_name }
                                            </Option>
                                        )) }
                                    </Select>
                                </Form.Item>
                            </Col>{ " " }
                            <Col sm={ 24 } md={ 24 }>
                                <Form.Item
                                    className="radio_group leave-radio"
                                    name="leave_status"
                                    initialValue={ val }
                                >
                                    <Radio.Group
                                        name="radiogroup"
                                        className="start-enddate"
                                        onChange={ onChange }
                                        value={ val }
                                    >
                                        <Radio value="All">All</Radio>
                                        <Radio value="Pending">Pending</Radio>
                                        <Radio value="Accepted">Approved</Radio>
                                        <Radio value="Rejected">Rejected</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <div className="add-leave-button">
                                    <Button type="primary" htmlType="submit">
                                        Apply
                                    </Button>
                                    <Button
                                        type="primary"
                                        className="ant-delete"
                                        style={ { marginLeft: "10px" } }
                                        onClick={ () => {
                                            form.resetFields();
                                            setVal("All");
                                            setFilterData([]);
                                        } }
                                    >
                                        Reset
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Modal>
            <Card className="main-content-wrapper" >

                <div className="search-wrapper">

                    <Search
                        placeholder="Search..."
                        onSearch={ karmaRewardGet }
                        onChange={ (e) => { setEmployeeNameTxt(e.target.value) } }
                        onPressEnter={ (e) => {
                            setEmployeeName(e.target.value);
                            karmaRewardGet();
                        } }
                        style={ { width: 200 } }
                        className="mr2"
                    />
                    <div className="filter-btns-wrapper">
                        <Form
                            ref={ filterFormRef }
                            className="filter-btns-wrapper"
                            layout="vertical"
                            onFinish={ karmaRewardGet }
                            onValuesChange={ handleFilterChange }
                        >
                            {/* Employee Name Input */ }
                            <Form.Item name="employeeName">
                                <Input
                                    value={ emplyeeName }
                                    onChange={ (e) => setEmployeeName(e.target.value) }
                                    placeholder="Enter employee name"
                                />
                            </Form.Item>

                            {/* Start Date Picker */ }
                            <Form.Item name="startDate">
                                <DatePicker
                                    placeholder="Select start date"
                                    value={ startDate ? moment(startDate) : null }
                                    onChange={ (date, dateString) => setStartDate(dateString) }
                                    format="DD-MM-YYYY"
                                    style={ { width: "100%" } }
                                />
                            </Form.Item>

                            {/* End Date Picker */ }
                            <Form.Item name="endDate">
                                <DatePicker
                                    placeholder="Select end date"
                                    value={ endDate ? moment(endDate) : null }
                                    onChange={ (date, dateString) => setEndDate(dateString) }
                                    format="DD-MM-YYYY"
                                    style={ { width: "100%" } }
                                />
                            </Form.Item>
                        </Form>

                        {/* <Button className="filter-btn" type="primary" onClick={ handFiltModal }>Filter</Button> */ }
                        <Button className="ant-delete delete-btn" onClick={ clearFilter }>
                            Reset
                        </Button>
                        { getResource(config.RESOURCES.WAFFLE_REWARD, ["update"]) && (
                            <>

                                <Button
                                      type="primary" className="add-btn"
                                    onClick={
                                        WaffleNameModalOpen
                                        //  handleAccept
                                    }
                                    disabled={ !selectedRowKeys.length > 0 }
                                >
                                    Approve
                                </Button>

                                <Button
                                    className="ant-reject"
                                    onClick={ handleReject }
                                    disabled={ !selectedRowKeys.length > 0 }
                                >
                                    Reject
                                </Button>

                            </>
                        ) }
                    </div>
                </div>

                <Modal
                    title="Add Waffle"
                    width={ 600 }
                    visible={ waffleNmaeModal }
                    footer={ null }
                    onCancel={ closeModal }
                >
                    <Form
                        layout="vertical"
                        form={ form }
                        onFinish={ handleFinish }
                    >
                        <Row gutter={ 16 }>
                            <Col span={ 24 }>
                                <Form.Item
                                    label="Waffle Name"
                                    name="waffleName"
                                    rules={ [
                                        { required: true, message: "Please enter the Waffle name" }
                                    ] }
                                >
                                    <Input placeholder="WFH,Leave,etc..." />
                                </Form.Item>
                            </Col>
                        </Row>

                        <div style={ { textAlign: "right", display: 'flex', gap: '5px' } }>
                            <Button onClick={ closeModal } style={ { marginRight: 10 } }>
                                Cancel
                            </Button>
                            <Button type="primary" htmlType="submit">
                                Add Waffle
                            </Button>
                        </div>
                    </Form>
                </Modal>

                <div className='main-table-wrapper'>
                    <Table
                      locale={ { emptyText: <NodataFoundIcon/> } }
                        columns={ columns }
                        pagination={ {
                            ...TABLE_PAGINATION,
                            total: totalRecord,
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                        } }
                        rowSelection={ rowSelection }
                        footer={ getFooterDetails }
                        onChange={ handleTableChange }
                        dataSource={ eventApiData.map((item, index) => ({
                            ...item,
                            key: item._id || index,
                        })) }
                        rowClassName={ (record) =>
                            record?.status !== "pending" ? "disabled-row" : ""
                        }
                    />
                </div>
            </Card>

            <Modal
                title="Filter"
                visible={ isVisible }
                onCancel={ () => { setisVisible(false) } }
                footer={ null }
            >
                <Form layout="vertical" onFinish={ karmaRewardGet }>
                    <Form.Item label="Employee Name">
                        <Input
                            value={ emplyeeName }
                            onChange={ (e) => setEmployeeName(e.target.value) }
                            placeholder="Enter employee name"
                        />
                    </Form.Item>

                    <Form.Item label="Start Date">
                        <DatePicker
                            value={ startDate ? moment(startDate) : null }
                            onChange={ (date, dateString) => setStartDate(dateString) }
                            format="DD-MM-YYYY"
                            style={ { width: "100%" } }
                        />
                    </Form.Item>

                    <Form.Item label="End Date">
                        <DatePicker
                            value={ endDate ? moment(endDate) : null }
                            onChange={ (date, dateString) => setEndDate(dateString) }
                            format="DD-MM-YYYY"
                            style={ { width: "100%" } }
                        />
                    </Form.Item>

                    <Button type="primary" className="filter-btn" htmlType="submit">
                        Filter
                    </Button>
                </Form>
            </Modal>
        </Card>
    )
}

export default KarmaApprovelAdmin



